import { render, staticRenderFns } from "./SoftwareLicenseView.vue?vue&type=template&id=8cfd823a&scoped=true&"
import script from "./SoftwareLicenseView.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseView.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicenseView.vue?vue&type=style&index=0&id=8cfd823a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfd823a",
  null
  
)

export default component.exports